import WithEncodingReadingBase from 'core/pages/Shipping/WithEncoding/WithEncodingReading'
import { ProductInfoField } from 'stylewhere/api'
import { T, __ } from 'stylewhere/shared/i18n'

export default class WithEncodingReading extends WithEncodingReadingBase {
  getProductInfoFields: () => ProductInfoField[] | undefined = () => {
    return [
      { label: __(T.misc.size), path: 'size.value' },
      { label: __(T.misc.color), path: 'color.value' },
      { label: __(T.misc.material), path: 'material.value' }
    ]
  }
}
